/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { MediaLibraryComponent } from '@app/shared/components/media-library/media-library/media-library.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MediaLibraryAcceptTypes } from '@app/shared/components/media-library/media-library-accept-types.enum';

@Component({
  selector: 'app-media-library-button',
  templateUrl: './media-library-button.component.html',
  styleUrls: ['./media-library-button.component.scss'],
})
export class MediaLibraryButtonComponent implements OnInit {
  /*
  Required parameters
   */
  @Input() modelId: number;
  @Input() modelType: LaravelModelsEnum;

  /*
  Optional parameters
   */
  @Input() acceptType: MediaLibraryAcceptTypes = MediaLibraryAcceptTypes.IMAGES;
  @Input() collectionName: string;
  @Input() icon = 'fal fa-image';
  @Input() btnClass = 'btn btn-warning btn-ico';

  @Input() localesFeature = false;

  constructor(private modalService: NgbModal) {}

  ngOnInit() {
    this.checkRequiredFields(this.modelId);
    this.checkRequiredFields(this.modelType);
  }

  open() {
    const modal = this.modalService.open(MediaLibraryComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.modelId = this.modelId;
    modal.componentInstance.modelType = this.modelType;
    modal.componentInstance.acceptType = this.acceptType;
    modal.componentInstance.localesFeature = this.localesFeature;

    if (this.collectionName) {
      modal.componentInstance.collectionName = this.collectionName;
    }
    return modal.result;
  }

  private checkRequiredFields(input: any): void {
    if (input === null || input === undefined) {
      throw new Error('MediaLibraryButtonComponent Missing required attribute');
    }
  }
}
